<template>
  <div class="about">
    <!-- <div class="about_w"> -->
    <div class="about1">
      <div class="about_tit">
        DO Network is a <br />decentralized network with<br />
        ultra-high performance.
      </div>
      <div class="about_tit1">
        It has achieved a scalable DPOS consensus agreement through a number of
        technological innovations,which we call Wave<br />
        Consensus,so as to achieve more unimaginable TPS performance.
      </div>
    </div>
    <div class="about2">
      <div class="tit">Key features</div>
      <div class="con">
        <div class="aboutbox">
          <img src="../../assets/pc/about/about1.png" class="img1" />
          <div class="tit1">Ultra-high Performance</div>
          <div class="tit2">
            Block time less than 0.1 second, TPS more than 1000
          </div>
        </div>
        <div class="aboutbox">
          <img src="../../assets/pc/about/about2.png" class="img2" />
          <div class="tit1">Extreme Low Gas</div>
          <div class="tit2">
            Use 1 dollar to complete more than 10,000 transactions
          </div>
        </div>
        <div class="aboutbox">
          <img src="../../assets/pc/about/about3.png" class="img3" />
          <div class="tit1">Easy Access To Join</div>
          <div class="tit2">
            20,000 DO to run a node, 1,500 DO to stake and win APY
          </div>
        </div>
        <div class="aboutbox">
          <img src="../../assets/pc/about/about4.png" class="img4" />
          <div class="tit1">Innovative Technology</div>
          <div class="tit2">
            Wave value consensus with EVM-equivalent compatibility
          </div>
        </div>
      </div>
    </div>
    <div class="about3">
      <div class="tit">Why “DO” matters?</div>
      <div class="con">
        DO Network is the most decentralized network for Web3 citizens to join,
        build and run. We devote ourselves to building a<br />
        low-threshold network for every DO builder, so that each attendant
        doesn’t need to satisfy complicated verification to join the<br />
        network. You are easy and welcome to play an important role with easy
        access.
      </div>
    </div>
    <div class="about4">
      <div class="tit">How does DO differ from other Layer 1?</div>
      <div class="con">
        DO network focus on the most basic and most critical factors for a Layer
        1 blockchain.
      </div>
      <div class="aboutbox">
        <div class="boxli">
          <img src="../../../src/assets/pc/about/about5.png" />
          <div class="litit">Performance</div>
          <div class="licon">
            Performance is the key feature for a Layer<br />
            to get mass adoption. Some Layer 1<br />
            blockchain have a good TPS, however,<br />
            when a huge traffic occurs, the<br />
            performance will become worse. Do<br />
            network offers users a stable and smooth<br />
            experience whenever users visit, based<br />
            on our unique “Wave Consensus”.
          </div>
        </div>
        <div class="boxli">
          <img src="../../../src/assets/pc/about/about6.png" />
          <div class="litit">Decentralization</div>
          <div class="licon">
            Decentralization is the basic feature of<br />
            blockchain, however, not all blockchains<br />
            really make it true. Web3 builders can<br />
            find that there are huge barriers to stop<br />
            them from being nodes and participate in<br />
            building the blockchain network. Do <br />network makes it easy for
            builders to join<br />
            in the network and become part of it, and<br />
            governance right is back to the people.
          </div>
        </div>
        <div class="boxli">
          <img src="../../../src/assets/pc/about/about7.png" />
          <div class="litit">Community</div>
          <div class="licon">
            No blockchain system can develop<br />
            without community. Do network has built<br />
            a strong community of over 100,000 <br />members from all over the
            world and<br />
            each member is part of the network,<br />
            keeping building and protecting it.
          </div>
        </div>
      </div>
    </div>
    <div class="about5">
      <div class="aboutbox">
        <div class="tit">What is Wave Consensus?</div>
        <div class="tit1">
          The wave protocol of Do network is a special consensus algorithm,
          which is driven by local consensus to reach an agreement across<br />
          the network, just like the wave driving gradually covers the entire
          sea area, so we call it the wave consensus protocol.
        </div>
        <div class="box">
          <div class="left"></div>
          <div class="right">
            <div class="rtit">The goal of the wave consensus protocol</div>
            <div class="rcon">
              We hope that the consensus process is safe, simple and efficient,
              which is designed to improve the overall performance of the
              network.
            </div>
          </div>
        </div>
        <div class="box box1">
          <div class="left left1"></div>
          <div class="right">
            <div class="rtit">Algorithm of the wave consensus protocol</div>
            <div class="rcon">
              The generated random number and the time axis combine to form a
              smooth and unpredictable trajectory by adopting the dual VRF
              random algorithm. Do<br />
              Network will elect a candidate from the legal verification nodes
              of the whole network. The consensus of 2/3 nodes of the whole
              network can be completed<br />
              only after the candidate and verifiers of different groups reach
              an agreement on the transaction.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about6">
      <div class="aboutl">
        <div class="tit">How is the DO network developing?</div>
        <div class="tit1">
          Since the DO mainnet launched in 2021, the DO network has<br />
          been running stably for more than 3 years.
        </div>
        <div class="tit2">
          We have built more than 200 nodes around the world, and a huge amount
          of<br />
          applications has been participated in the DO ecosystem, including
          wallet, Defi,<br />
          NFT, meme coins, AI, etc.
        </div>
        <img src="../../../src/assets/pc/about/about9.png" />
      </div>
      <div class="aboutr">
        <img src="../../../src/assets/pc/about/about8.png" />
        <div class="tit">
          We always regard ecosystem applications as a key part of<br />
          DO network and have always been supporting our DO<br />
          applications by granting DO token, helping promote,<br />
          holding application competitions, technique supporting,<br />
          etc.
        </div>
      </div>
    </div>
    <div class="about7">
      <div class="line"></div>
    
      <div class="linkbox">
        <div class="tit">
          If you are a DO developer with your DO application, you can<br />
          submit it <a @click="onhere">here</a> and get various forms of support from
          DO network.
        </div>
        <img src="../../../src/assets/pc/about/about10.png" />
      </div>
      <div class="line"></div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    onhere(){
      this.$router.push('/pc/GrantApplication')
    },
  },
};
</script>
<style lang="less">
.w1352 {
  width: 1200px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.about {
  width: 100%;
  overflow: hidden;
  background: #fff;
  .about1 {
    width: 1190px;
    margin: 0 auto;
    margin-top: 159px;
    .about_tit {
      font-family: Poppins, Poppins;
      font-weight: 900;
      font-size: 80px;
      color: #000000;
      line-height: 112px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .about_tit1 {
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 18px;
      color: #61666b;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 20px;
    }
  }
  .about2 {
    width: 1190px;
    margin: 0 auto;
    padding-bottom: 140px;
    .tit {
      height: 34px;
      font-family: Poppins, Poppins;
      font-weight: 700;
      font-size: 24px;
      color: #000000;
      line-height: 34px;
      text-align: left;
      margin-top: 100px;
      margin-bottom: 20px;
    }
    .con {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .aboutbox {
        width: 565px;
        height: 217px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 15px 15px 15px 15px;
        border: 2px solid #e4e4e6;
        margin-bottom: 60px;
        .img1 {
          width: 45px;
          height: 54px;
          margin-top: 38px;
          margin-left: 60px;
        }
        .img2 {
          width: 45px;
          height: 40px;
          margin-top: 52px;
          margin-left: 60px;
        }
        .img3 {
          width: 39px;
          height: 44px;
          margin-top: 58px;
          margin-left: 60px;
        }
        .img4 {
          margin-top: 55px;
          margin-left: 60px;
          width: 48px;
          height: 46px;
        }
        .tit1 {
          height: 31px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 18px;
          color: #2c1d1a;
          line-height: 31px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-top: 18px;
          margin-left: 60px;
        }
        .tit2 {
          height: 24px;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 14px;
          color: #737582;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 60px;
        }
      }
      .aboutbox:hover {
        width: 565px;
        height: 217px;
        background: rgba(255, 255, 255, 0.3);
        box-shadow: 0px 7px 35px 0px rgba(69, 115, 231, 0.2);
        border-radius: 15px 15px 15px 15px;
        border: 2px solid rgba(82, 124, 233, 0.2);
      }
    }
  }
  .about3 {
    background: url("../../assets/pc/about/about11.png") no-repeat;
    background-size: cover;
    height: 304px;
    .tit {
      width: 1190px;
      margin: 0 auto;
      padding-top: 80px;
      font-family: Poppins, Poppins;
      font-weight: 700;
      font-size: 24px;
      color: #000000;
    }
    .con {
      width: 1190px;
      margin: 0 auto;
      font-family: Poppins, Poppins;
      font-weight: 400;
      font-size: 18px;
      color: #737582;
      line-height: 31px;
      margin-top: 18px;
    }
  }
  .about4 {
    width: 1190px;
    margin: 0 auto;
    padding-bottom: 140px;
    .tit {
      height: 34px;
      font-family: Poppins, Poppins;
      font-weight: 700;
      font-size: 24px;
      color: #000000;
      line-height: 34px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 140px;
    }
    .con {
      height: 31px;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 18px;
      color: #737582;
      line-height: 31px;
      text-align: left;
      margin-top: 6px;
    }
    .aboutbox {
      display: flex;
      justify-content: space-between;
      .boxli {
        width: 356px;
        height: 443px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 15px 15px 15px 15px;
        border: 2px solid #f1f1f2;
        margin-top: 60px;
        img {
          width: 145px;
          height: 145px;
        }
        .litit {
          height: 31px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 18px;
          color: #2c1d1a;
          line-height: 31px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 30px;
        }
        .licon {
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 14px;
          color: #737582;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 30px;
          margin-top: 14px;
        }
      }
      .boxli:hover {
        width: 356px;
        height: 443px;
        background: rgba(255, 255, 255, 0.3);
        box-shadow: 0px 7px 35px 0px rgba(69, 115, 231, 0.2);
        border-radius: 15px 15px 15px 15px;
        border: 2px solid rgba(82, 124, 233, 0.2);
      }
    }
  }
  .about5 {
    background: url("../../assets/pc/about/about12.png") no-repeat;
    background-size: cover;
    height: 562px;
    .aboutbox {
      width: 1190px;
      margin: 0 auto;
      padding-top: 80px;
      .tit {
        height: 34px;
        font-family: Poppins, Poppins;
        font-weight: 700;
        font-size: 24px;
        color: #000000;
        line-height: 34px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .tit1 {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 18px;
        color: #737582;
        line-height: 31px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 6px;
        margin-bottom: 67px;
      }
      .box {
        display: flex;
        margin-top: 20px;
        height: 89px;
        padding-top: 13px;
        .left {
          width: 6px;
          height: 6px;
          background: #4573e7;
          border-radius: 50%;
          margin-left: 34px;
          margin-top: 12px;
        }
        .left1 {
          background: #e74545;
        }
        .right {
          margin-left: 12px;
          .rtit {
            height: 31px;
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 18px;
            color: #2c1d1a;
            line-height: 31px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          .rcon {
            margin-top: 6px;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 14px;
            color: #737582;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
      }
      .box1 {
        height: 139px;
      }
      .box:hover {
        width: 1190px;

        background: rgba(255, 255, 255, 0.7);
        border-radius: 8px 8px 8px 8px;
        border: 2px solid #ffffff;
      }
    }
  }
  .about6 {
    width: 1190px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: 140px;
    padding-bottom: 157px;
    .aboutl {
      .tit {
        height: 34px;
        font-family: Poppins, Poppins;
        font-weight: 700;
        font-size: 24px;
        color: #000000;
        line-height: 34px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .tit1 {
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 18px;
        color: #2c1d1a;
        line-height: 31px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 40px;
      }
      .tit2 {
        margin-top: 6px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 14px;
        color: #737582;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 6px;
      }
      img {
        width: 245px;
        height: 258px;
        margin-top: 146px;
        margin-left: 158px;
      }
    }
    .aboutr {
      img {
        width: 246px;
        height: 253px;
        margin-top: 48px;
        margin-left: 110px;
      }
      .tit {
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 18px;
        color: #2c1d1a;
        line-height: 32px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 106px;
      }
    }
  }
  .about7 {
    padding-bottom: 270px;
    .line {
      width: 1190px;
      margin: 0 auto;
     // height: 2px;
     // background: #cccdd1;
      border: 1px solid #cccdd1;
      // border-radius: 0px 0px 0px 0px;
      margin-bottom: 60px;
    }
    .linkbox {
      width: 705px;
      margin: 0 auto;
      display: flex;
      margin-bottom: 60px;
      .tit {
        width: 602px;
        height: 64px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 18px;
        color: #000000;
        line-height: 32px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        a{
          text-decoration: underline;
          color: #4573E7;
          cursor: pointer;
        }
      }
      img{
        width: 75px;
        height: 81px;
      }
    }
  }
}
</style>
